import { ApiErrorResponseSchema, ApiErrorCode } from './error-codes.js';

export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly statusText: string,
    public readonly body: unknown,
  ) {
    super(`API error ${status}: ${statusText}`);
    this.name = 'ApiError';
  }
}

export interface ParsedApiError {
  statusCode: number;
  errorCode: ApiErrorCode;
  message: string;
  details: unknown | undefined;
}

export function isNotFoundError(error: unknown): boolean {
  const parsed = parseApiError(error);
  return parsed.statusCode === 404 || parsed.errorCode === ApiErrorCode.NOT_FOUND;
}

export function isExpiredLinkError(error: unknown): boolean {
  const parsed = parseApiError(error);
  return parsed.statusCode === 410 || parsed.errorCode === ApiErrorCode.PUBLIC_LINK_EXPIRED;
}

export function parseApiError(error: unknown): ParsedApiError {
  if (!(error instanceof ApiError)) {
    return {
      statusCode: 0,
      errorCode: ApiErrorCode.INTERNAL_ERROR,
      message: 'An unexpected error occurred',
      details: undefined,
    };
  }

  const result = ApiErrorResponseSchema.safeParse(error.body);
  if (result.success) {
    return {
      statusCode: result.data.statusCode,
      errorCode: result.data.errorCode,
      message: result.data.message,
      details: result.data.details,
    };
  }

  return {
    statusCode: error.status,
    errorCode: ApiErrorCode.INTERNAL_ERROR,
    message: error.statusText,
    details: undefined,
  };
}
